module.exports = __webpack_public_path__ + "img/bank_check.8cbb5aa5.svg";